import type { TimesheetModule } from '@bc-library/interface'

export const TIMESHEET_SETTING_ACCESS_KEYS = [
  'settingsActivitiesAccess',
  'settingsDailyDetailsAccess',
] as const

export type TimesheetSettingAccessKey = typeof TIMESHEET_SETTING_ACCESS_KEYS[number]

export const hasAnyTimesheetSettingsAccess = (timesheet?: TimesheetModule) => {
  if (!timesheet)
    return false
  if (timesheet.settingsAccess)
    return true
  return TIMESHEET_SETTING_ACCESS_KEYS.some(key => timesheet[key])
}

export const hasTimesheetSettingAccess = (
  timesheet: TimesheetModule | undefined,
  key: TimesheetSettingAccessKey,
) => {
  if (!timesheet)
    return false
  if (timesheet.settingsAccess)
    return true
  return !!timesheet[key]
}
